
jQuery.fn.swap = function(b){
    b = jQuery(b)[0];
    var a = this[0];
    var t = a.parentNode.insertBefore(document.createTextNode(''), a);
    b.parentNode.insertBefore(a, b);
    t.parentNode.insertBefore(b, t);
    t.parentNode.removeChild(t);
    return this;
};

function FloorPlanLiPlanEditContent(modal)
{
    this.init(modal);
    return this;
}

$.extend(FloorPlanLiPlanEditContent.prototype,{
    modal:null,
    $el:null,
    el:null,
    template:'<div class="form-group fg-float">' +
    '<div class="fg-line">' +
    '<input class="form-control fg-input name-field"/>' +
    '<label class="fg-label">'+window.LANGUAGE['floorplan.modal.fields.name']+'</label>' +
    '</div>' +
    '</div><br/>' +
    '<div class="form-group fg-float">' +
    '<div class="fg-line">' +
    '<input class="form-control fg-input value-field"/>' +
    '<label class="fg-label">'+window.LANGUAGE['floorplan.modal.fields.value']+'</label>' +
    '</div>' +
    '</div>',
    data:{
        name:'',
        value:''
    },
    init:function(modal)
    {
        this.data={
            name:'',
            value:''
        };

        this.modal=modal;
        this.$el=$("<div></div>");
        this.el=this.$el[0];
        this.config= this.modal.modalOpts.config;
        if(this.config.isnew)
        {
            this.modal.setOptions({
                title:window.LANGUAGE['floorplan.modal.newarea.title'],
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-link',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'create',
                        title:window.LANGUAGE['basic.apply'],
                        style:'btn-success',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    }
                ]
            });
        }else{
            this.modal.setOptions({
                title:window.LANGUAGE['floorplan.modal.editarea.title'],
                buttons:[
                    {
                        'id':'delete',
                        title:window.LANGUAGE['basic.delete'],
                        style:'btn-danger pull-left',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-link',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'save',
                        title:window.LANGUAGE['basic.apply'],
                        style:'btn-success',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    }
                ]
            });
            this.data.name=this.config.name;
            this.data.value=this.config.value;
        }

        setTimeout(this.modal.render.bind(this.modal),0);
        this.render();
    },
    render:function()
    {
        this.$el.html(this.template);
        this.nameField=this.$el.find(".name-field");
        this.nameField.val(this.data.name);
        if(this.data.name.length)
            this.nameField.parent().addClass("fg-toggled");
        this.valueField=this.$el.find(".value-field");
        this.valueField.val(this.data.value);
        if(this.data.value.length)
            this.valueField.parent().addClass("fg-toggled");
    },
    onModalEvent:function(buttonId)
    {
        switch(buttonId)
        {
            case "delete":
                this.config.controller.onDelete();
                break;
            case "create":
                this.grabData();
                this.config.controller.onCreate(this.data);
                break;
            case "save":
                this.grabData();
                this.config.controller.onSave(this.data);
                break;
            case "cancel":
                this.config.controller.onCancel(this.config.isnew);
                break;
        }
    },
    grabData:function()
    {
        this.data.name=this.nameField.val();
        this.data.value=this.valueField.val();
    }
});

function FloorPlanLiPlan()
{
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

$.extend(FloorPlanLiPlan.prototype,{
    name:'',
    template:'<li><span class="drager left"><i class="zmdi zmdi-arrows"></i></span><span class="drager right"><i class="zmdi zmdi-arrows"></i></span> <span class="editor"><i class="zmdi zmdi-edit"></i></span>' +
    '<span class="name"></span></li>',
    parent:null,
    $el:null,
    el:null,
    options:{
        change:function(){}
    },
    left:null,
    right:null,
    handled:'none',
    data:{
        x1:0,
        y1:0,
        x2:0.5,
        y2:0.5,
        name:'',
        value:''
    },
    firstpoint:{
        x:0,
        y:0
    },
    originalposition:{
        x:0,
        y:0
    },
    parentdimensions:{
        width:0,
        height:0
    },
    init:function(options) {
        this.parent=options.parent;
        $.extend(this.options,options);
        if(options.data)
            this.data=options.data;
        this.$el=$(this.template);
        this.parent.append(this.$el);
        this.el=this.$el[0];

        this.$el.draggable({ containment: this.parent, scroll: false, drag:this.onDrag.bind(this) });
        this.left=this.$el.find(".drager.left");
        this.right=this.$el.find(".drager.right");
        this.parent.on("mousemove",this.onMouseMove.bind(this));
        this.parent.on("mouseup",this.onLeftUp.bind(this));
        this.left.on("mousedown",this.onLeftDown.bind(this));
        this.left.on("mouseup",this.onLeftUp.bind(this));
        this.right.on("mousedown",this.onRightDown.bind(this));
        this.right.on("mouseup",this.onRightUp.bind(this));
        this.setName(this.data.name);
        this.setPositionFromData();
        this.$el.find(".editor").on("click",function(e){
            e.preventDefault();
            this.edit(false);
            return false;
        }.bind(this)).on("mousedown",function(){return false;});
        this.render();
        if(this.options.isnew)
        {
            this.edit(true);
        }
    },
    reomve:function()
    {
        this.parent.off("mousemove",this.onMouseMove.bind(this));
    },
    render:function()
    {
        this.$el.find(".name").text(this.name);
    },
    setName:function(name)
    {
        this.name=name;
        this.render();
    },
    getName:function()
    {
        return name;
    },
    onDrag:function(){
        this.parentdimensions.width=this.parent.width();
        this.parentdimensions.height=this.parent.height();
        this.data.x1=parseInt(this.$el.css("left"))/this.parentdimensions.width;
        this.data.y1=parseInt(this.$el.css("top"))/this.parentdimensions.height;
        this.data.x2=(parseInt(this.$el.css("left"))+this.$el.width())/this.parentdimensions.width;
        this.data.y2=(parseInt(this.$el.css("top"))+this.$el.height())/this.parentdimensions.height;
    },
    onMouseMove:function(e){
        if(this.handled!='none')
            e.preventDefault();
        if(this.handled=='none')
            return true;
        var dX=e.clientX-this.firstpoint.x;
        var dY=e.clientY-this.firstpoint.y;

        switch(this.handled)
        {
            case "left":
                this.data.x1=(dX+this.originalposition.x)/this.parentdimensions.width;
                this.data.y1=(dY+this.originalposition.y)/this.parentdimensions.height;
                //this.data.x2=(this.originalposition.x+(this.originalposition.width-dX))/this.parentdimensions.width;
               // this.data.y2=(this.originalposition.y+(this.originalposition.height-dY))/this.parentdimensions.height;
                break;
            case "right":
                this.data.x2=(dX+this.originalposition.x+this.originalposition.width)/this.parentdimensions.width;
                this.data.y2=(dY+this.originalposition.y+this.originalposition.height)/this.parentdimensions.height;
                break;
        }

        if(this.data.x1>1)
            this.data.x1=1;
        if(this.data.x2>1)
            this.data.x2=1;
        if(this.data.y1>1)
            this.data.y1=1;
        if(this.data.y2>1)
            this.data.y2=1;

        if(this.data.x1<0)
            this.data.x1=0;
        if(this.data.x2<0)
            this.data.x2=0;
        if(this.data.y1<0)
            this.data.y1=0;
        if(this.data.y2<0)
            this.data.y2=0;

        this.setPositionFromData();
    },
    onLeftDown:function(e)
    {
        e.preventDefault();
        this.handled='left';
        if(!this.$el.hasClass("force-opacity"))
            this.$el.addClass("force-opacity");
        this.firstpoint.x=e.clientX;
        this.firstpoint.y=e.clientY;
        this.originalposition.x=parseInt(this.$el.css("left"));
        this.originalposition.y=parseInt(this.$el.css("top"));
        this.originalposition.width=this.$el.width();
        this.originalposition.height=this.$el.height();
        return false;
    },
    onLeftUp:function(e)
    {
        e.preventDefault();
        this.handled='none';
        if(this.$el.hasClass("force-opacity"))
            this.$el.removeClass("force-opacity");
        return false;
    },
    onRightDown:function(e)
    {
        e.preventDefault();
        this.handled='right';
        if(!this.$el.hasClass("force-opacity"))
            this.$el.addClass("force-opacity");
        this.firstpoint.x=e.clientX;
        this.firstpoint.y=e.clientY;
        this.originalposition.x=parseInt(this.$el.css("left"));
        this.originalposition.y=parseInt(this.$el.css("top"));
        this.originalposition.width=this.$el.width();
        this.originalposition.height=this.$el.height();
        return false;
    },
    onRightUp:function(e)
    {
        e.preventDefault();
        this.handled='none';
        if(this.$el.hasClass("force-opacity"))
            this.$el.removeClass("force-opacity");
        return false;
    },
    setPositionFromData:function()
    {
        this.parentdimensions.width=this.parent.width();
        this.parentdimensions.height=this.parent.height();

        this.$el.css({
            left:this.data.x1*this.parentdimensions.width,
            top:this.data.y1*this.parentdimensions.height,
            width:(this.data.x2-this.data.x1)*this.parentdimensions.width,
            height:(this.data.y2-this.data.y1)*this.parentdimensions.height
        });
    },
    edit:function(isnew)
    {
        var modal=new ModalWrapper({
            content:FloorPlanLiPlanEditContent,
            config:{
                name:this.data.name,
                value:this.data.value,
                isnew:isnew?true:false,
                controller:this
            }
        });
        modal.show();
    },
    onCreate:function(data)
    {
        this.data.name=data.name;
        this.data.value=data.value;
        this.setName(this.data.name);
        this.options.controller.addNewPlan(this);
    },
    onDelete:function()
    {
        this.$el.remove();
        this.options.controller.removePlan(this);
    },
    onCancel:function(isnew)
    {
        if(isnew)
        {
            this.$el.remove();
        }
    },
    onSave:function(data)
    {
        this.data.name=data.name;
        this.data.value=data.value;
        this.setName(this.data.name);
    }
});



var IdFloorPlan=0;
function FloorPlanContent()
{
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

$.extend(FloorPlanContent.prototype, {
    modal:null,
    el:null,
    $el:null,
    template:'<div class="floorplan">' +
    '<div class="form-group fg-float">' +
    '<div class="fg-line"> <input class="input-sm form-control fg-input name-field-here" type="text"> <label class="fg-label">'+window.LANGUAGE['floorplan.fields.name']+'</label> </div>  ' +
    '</div>' +
    '<p>'+window.LANGUAGE['floorplan.fields.floorplan-description']+'</p>' +
    '<div class="image-area"> ' +
    '<label for="floorplan"><i class="zmdi zmdi-upload"></i>&nbsp; Drop image here</label> ' +
    '<input id="files" type="file" /> ' +
    '<img src="#"/> ' +
    '<ul class="areas"><span class="helper">'+window.LANGUAGE['floorplan.helper']+'</span></ul>' +
    '</div></div></div>',
    img:null,
    areas:null,
    makenew:false,
    firstpoint:{x:0,y:0},
    ghost:null,
    collection:[],
    data:{
        icon:'default',
        published:true,
        name:'',
        image:{
            raw:null,
            media_id:null,
            salt:null
        },
        areas:[]
    },
    original:null,
    init:function(modal) {
        this.modal=modal;
        this.$el=$("<div></div>");
        this.el=this.$el[0];
        this.config=this.modal.modalOpts.config;
        if(this.config.isnew) {
            this.data=_.clone(this.data);
            this.modal.setOptions({
                title: 'Floorplan - New',
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-link',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'create',
                        title:window.LANGUAGE['basic.apply'],
                        style:'btn-success',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    }
                ]
            });
        }else{
            this.original=this.config.data;
            this.data=_.clone(this.original);
            this.modal.setOptions({
                title: window.LANGUAGE['floorplan.edit'],
                buttons:[
                    {
                        'id':'delete',
                        title:window.LANGUAGE['basic.delete'],
                        style:'btn-danger pull-left',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-link',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    },
                    {
                        'id':'save',
                        title:window.LANGUAGE['basic.apply'],
                        style:'btn-success',
                        cbs:[this.onModalEvent.bind(this)],
                        event:'close'
                    }
                ]
            });
        }
        setTimeout(this.modal.render.bind(this.modal),0);
        this.render();
        this.modal.onShow(this.rerenderAreas.bind(this));
    },
    rerenderAreas:function()
    {
        for(var i=0;i<this.collection.length;i++)
        {
            this.collection[i].setPositionFromData();
            this.collection[i].render();
        }
    },
    render:function() {
        IdFloorPlan++;
        this.$el.html(this.template);
        var input=this.$el.find(".image-area input");
        input.attr("id","floorplan_id_"+IdFloorPlan);
        this.$el.find(".image-area label").attr("for","floorplan_id_"+IdFloorPlan);
        input.hide();
        this.img=this.$el.find(".image-area img");
        this.img.hide();
        var imgarea=this.$el.find(".image-area")[0];
        imgarea.addEventListener('dragover', this.handleDragOver.bind(this));
        imgarea.addEventListener('dragleave', this.handleDragLeave.bind(this));
        imgarea.addEventListener('drop', this.handleDrop.bind(this));
        input[0].addEventListener('change', this.handleFileSelect.bind(this));
        this.areas=this.$el.find(".image-area .areas");
        this.areas.on("mousedown",this.onMouseDown.bind(this));
        this.areas.on("mouseup",this.onMouseUp.bind(this));
        this.areas.on("mousemove",this.onMouseMove.bind(this));
        this.$el.find(".name-field-here").val(this.data.name);
        if(this.data.name.length)
            this.$el.find(".name-field-here").parent().addClass("fg-toggled");
        //check image
        if(this.data.image.media_id)
        {
            this.img[0].onload=function(){
                this.rerenderAreas();
            }.bind(this);
            this.img.attr("src","/media/0x0/"+this.data.image.media_id+"_"+this.data.image.salt);
            this.img.fadeIn();
            this.imageComplete();
        }
        else if(this.data.image.raw) {
            this.img[0].onload=function(){
                this.rerenderAreas();
            }.bind(this);
            this.img.attr("src",this.data.image.raw);
            this.img.fadeIn();
            this.imageComplete();
        }

        setTimeout(function(){
            this.collection=[];
            for(var i=0;i<this.data.areas.length;i++)
            {
                var obj=this.data.areas[i];
                this.collection.push(new FloorPlanLiPlan({
                    parent:this.areas,
                    isnew:false,
                    data:{
                        x1:obj.x1,
                        x2:obj.x2,
                        y1:obj.y1,
                        y2:obj.y2,
                        name:obj.title,
                        value:obj.fields[0].value
                    },
                    controller:this
                }));
            }
        }.bind(this),0);
    },
    handleDragOver: function (e) {
        e.preventDefault();
        if(!this.$el.find(".image-area label").hasClass("filedrop"))
            this.$el.find(".image-area label").addClass("filedrop");
    },
    handleDragLeave: function (e) {
        e.preventDefault();
        this.$el.find(".image-area label").removeClass("filedrop");
    },
    handleDrop:function (e) {
        e.preventDefault();
        this.$el.find(".image-area label").removeClass("filedrop");
        this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
    },
    handleFileSelect:function(e) {
        this.handleFileItems(e.target.files);
    },
    handleFileItems:function(items)
    {
        var l = items.length;
        for (var i=0; i<l; i++) {
            this.handleItem(items[i]);
        }
    },
    handleItem:function(item)
    {
        var file = item;
        if (item.getAsFile && item.kind =='file') {
            file = item.getAsFile();
        }
        this.handleFile(file);
    },
    handleFile:function(file)
    {
        var reader = new FileReader();
        var self=this;
        // Closure to capture the file information.
        self.$el.find(".image-area img").fadeOut(function(){
            reader.onload = (function(theFile) {
                return function(e) {
                    // Render thumbnail.


                    var imgCrop=new Image();
                    imgCrop.onload=function(){
                        var originalWidth=imgCrop.width;
                        var originalHeight=imgCrop.height;
                        var aspectRatio=originalWidth/originalHeight;
                        console.log("Loaded image",originalWidth,originalHeight);
                        console.log("aspect ratio",originalWidth/originalHeight);
                        if(aspectRatio==1) {
                            self.stackImage(e.target.result);
                            return;
                        }

                        var canvas=$("<canvas></canvas>")[0];
                        var context=canvas.getContext('2d');

                        if(originalWidth>originalHeight)
                        {
                            canvas.width=canvas.height=originalHeight;

                            //crop width into height
                            context.drawImage(imgCrop,
                                (originalWidth-originalHeight)/2, //source x
                                0, //source y
                                originalHeight, //source w
                                originalHeight, //source h
                                0, //destination x
                                0, //destination y
                                originalHeight, //destination w
                                originalHeight //destination h
                            );
                        }else{
                            //crop height into width
                            canvas.height=canvas.width=originalWidth;
                            context.drawImage(imgCrop,
                                0, //source x
                                (originalHeight-originalWidth)/2, //source y
                                originalWidth, //source w
                                originalWidth, //source h
                                0, //destination x
                                0, //destination y
                                originalWidth, //destination w
                                originalWidth //destination h
                            );
                        }

                        var imageSrc=canvas.toDataURL("image/jpeg");
                        self.stackImage(imageSrc);
                    };
                    imgCrop.src=e.target.result;


                };
            })(file);
            // Read in the image file as a data URL.
            reader.readAsDataURL(file);
        });
    },
    stackImage:function(imageraw)
    {
        this.data.image={
            media_id:null,
            salt:null,
            raw:imageraw
        };
        this.$el.find(".image-area img").attr('src',imageraw).fadeIn(function(){

        });
        this.imageComplete();
    },
    imageComplete:function()
    {
        this.$el.find(".image-area").addClass("image-complete");
    },
    onMouseDown:function(e)
    {
        if($(e.target).hasClass("areas")) {
            e.preventDefault();
            this.firstpoint.x = e.clientX;
            this.firstpoint.y = e.clientY;
            this.makenew = true;
            this.ghost = $('<span class="ghost"></span>');
            this.ghost.css({
                left: this.firstpoint.x - this.areas.offset().left + $(window).scrollLeft(),
                top: this.firstpoint.y - this.areas.offset().top + $(window).scrollTop(),
                opacity: 0
            });
            this.areas.append(this.ghost);
        }
    },
    onMouseUp:function(e)
    {
        e.preventDefault();
        this.makenew=false;
        if(this.ghost) {
            var l=Math.pow((e.clientX-this.firstpoint.x)*(e.clientX-this.firstpoint.x) + (e.clientY-this.firstpoint.y)*(e.clientY-this.firstpoint.y),0.5);
            var ndms = {
                x1: parseInt(this.ghost.css("left")) / this.areas.width(),
                y1: parseInt(this.ghost.css("top")) / this.areas.height(),
                x2: (parseInt(this.ghost.css("left")) + this.ghost.width()) / this.areas.width(),
                y2: (parseInt(this.ghost.css("top")) + this.ghost.height()) / this.areas.height(),
                name:'',
                value:''
            };
            if(l>=30) {
                new FloorPlanLiPlan({
                    parent: this.areas,
                    isnew: true,
                    data: ndms,
                    controller:this
                });
            }

            this.ghost.remove();
        }
        this.ghost=null;
    },
    onMouseMove:function(e)
    {
        e.preventDefault();
        if(this.makenew)
        {
            var dX=e.clientX-this.firstpoint.x;
            var dY=e.clientY-this.firstpoint.y;
            var l=Math.pow((e.clientX-this.firstpoint.x)*(e.clientX-this.firstpoint.x) + (e.clientY-this.firstpoint.y)*(e.clientY-this.firstpoint.y),0.5);
            l=l/30;
            l=l>1?1:l;
            this.ghost.css({
                width:dX,
                height:dY,
                opacity:l
            });
        }
    },
    addNewPlan:function(plan)
    {
        this.collection.push(plan);
        this.updateData();
    },
    removePlan:function(plan)
    {
        for(var i=0;i<this.collection.length;i++)
        {
            if(this.collection[i]===plan)
            {
                this.collection.splice(i,1);
                break;
            }
        }
        this.updateData();
    },
    updateData:function()
    {
        var tempData=[

        ];
        for(var i=0;i<this.collection.length;i++)
        {
            var obj=this.collection[i];
            var save={
                x1:obj.data.x1,
                x2:obj.data.x2,
                y1:obj.data.y1,
                y2:obj.data.y2,
                title:obj.data.name,
                fields:[
                    {
                        icon:'default',
                        value:obj.data.value
                    }
                ]
            };
            tempData.push(save);
        }
        this.data.areas=tempData;
        this.data.name=this.$el.find(".name-field-here").val();
    },
    onModalEvent:function(buttonId)
    {

        this.data.name=this.$el.find(".name-field-here").val();
        if(buttonId=="delete")
        {
            this.config.controller.removePlan(this.config.item);
            return;
        }

        if(buttonId=="save")
        {
            this.updateData();
            this.config.controller.updatePlan(this.original, _.clone(this.data));
            return;
        }

        if(buttonId=="create")
        {
            this.updateData();
            this.config.controller.appendPlan(_.clone(this.data));
            return;
        }

    }

});

function FloorPlanField()
{
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

$.extend(FloorPlanField.prototype, {
    el:null,
    $el:null,
    template:'<div class="floor-plan-list">' +
    '<div class="empty-list">'+window.LANGUAGE['floorplan.empty-list']+'</div>' +
    '</div>' +
    '<div class="floor-plan-buttons">' +
    '<button class="btn btn-success add-new-floorplan"><i class="zmdi zmdi-plus"></i> '+window.LANGUAGE['floorplan.add-item']+'</button>' +
    '</div>',
    planTemplate:'<div class="plan"><span class="name"></span> <span class="actions"><i class="zmdi zmdi-edit"></i></span></div>',
    floorPlanList:null,
    plans:[],
    cba:null,
    init:function(element,cba)
    {
        this.plans=[];
        this.cba= cba;
        this.el=element;
        this.$el=$(this.el);
        this.input=this.$el.find("input");

        try {
            var val = this.input.val();

            if (val.length)
                this.plans = JSON.parse(val);
        }catch(e){
            this.plans=[];
        }

        this.$el.html($(this.template));
        this.$el.append(this.input);
        this.floorPlanList=this.$el.find(".floor-plan-list");
        $("body").on("mousemove",_.bind(this.onMouseMove,this));
        $("body").on("mouseup",_.bind(this.onMouseUp,this));
        this.$el.find(".add-new-floorplan").on("click", this.addNewPlan.bind(this));
        this.render();
    },
    render:function()
    {
        this.$el.find(".floor-plan-list .plan").remove();
        this.$el.find(".floor-plan-list .empty-list")[this.plans.length?'hide':'show']();
        var list=this.$el.find(".floor-plan-list");

        var self=this;

        for(var i=0;i<this.plans.length;i++)
        {
            var obj=this.plans[i];
            if(!obj) { continue; }
            var plan=$(this.planTemplate);
            plan.find(".name").text(obj.name);
            plan.attr("data-id",i);
            plan.find(".actions").on("click",function(e){
                e.preventDefault();
                self.editPlan(self.plans[+$(this).parent().attr("data-id")],+$(this).parent().attr("data-id"));
                return false;
            }).on("mousedown",function(){return false;});
            plan.on("mousedown",_.bind(this.onMouseDown,this));
            list.append(plan);
        }

    },
    addNewPlan:function(e)
    {
        e.preventDefault();
        var modal=new ModalWrapper({
            content:FloorPlanContent,
            config:{
                isnew:true,
                controller:this,
                complete:this.appendPlan.bind(this)
            }
        });
        modal.show();
    },
    appendPlan:function(plan)
    {
        this.plans.push(plan);
        this.render();
        this.packValue();
    },
    editPlan:function(plan,item)
    {

        var modal=new ModalWrapper({
            content:FloorPlanContent,
            config:{
                isnew:false,
                controller:this,
                data:plan,
                item:item
            }
        });
        modal.show();
    },
    updatePlan:function(plan,updated)
    {
        for(var i=0;i<this.plans.length;i++)
        {
            if(this.plans[i]===plan)
            {
                this.plans[i]=updated;
                break;
            }
        }


        this.render();
        this.packValue();
    },
    removePlan:function(item)
    {
        this.plans.splice(item,1);

        this.render();
        this.packValue();
    },
    clearAllPlans:function()
    {
        this.plans=[];
        this.render();
        this.packValue();
    },
    packValue:function()
    {
        var packval=[];
        var self=this;
        this.floorPlanList.find(".plan").each(function(i,item) {
            packval.push(self.plans[$(item).attr("data-id")]);
        });
        if(this.cba) {
            this.cba(packval);
        }
        var json=JSON.stringify(packval);
        this.input.val(json);

        this.input.closest('form').attr('data-dirty',true);
    },
    updateFrom:function(val) {
        /*this.plans=val;
        this.render();*/
    },
    mouseDown:false,
    drag:false,
    dragElement:false,
    onMouseDown:function(e) {
        this.mouseDown=true;
        this.drag=false;
        this.dragElement=$(e.currentTarget);
        this.dragPhantom=this.dragElement.clone();
        this.dragElement.css("opacity",0.1);
        this.dragPhantom.addClass("ghost");
        this.floorPlanList.append(this.dragPhantom);
        //detect point click in Y
        var offset=(e.pageY-this.floorPlanList.offset().top)/55;
        var item=Math.floor(offset);

        this.clickOffset=(e.pageY-this.floorPlanList.offset().top)-Math.floor(offset)*55;
        this.dragPhantom.css("top",item*55+"px");
        console.log("mdown",offset);
        return false;
    },
    onMouseUp:function() {
        if(this.mouseDown) {
            this.mouseDown = false;
            this.drag = false;
            console.log("mup");
            this.dragElement.css("opacity", 1);
            this.dragPhantom.remove();
            this.packValue();
            //check and redraw
        }
    },
    onMouseMove:function(e) {
        if(this.mouseDown) {
            console.log("mmove");
            //check state and begin drag
            if(this.drag) {
                var ghostOffset=e.pageY-this.floorPlanList.offset().top-this.clickOffset;
                if(ghostOffset<0)
                    ghostOffset=0;
                if(ghostOffset>=this.floorPlanList.height()-55)
                    ghostOffset=this.floorPlanList.height()-55;

                var tOffset=ghostOffset+25+this.floorPlanList.offset().top;

                this.dragPhantom.css("top",ghostOffset+"px");
                var self=this;

                this.floorPlanList.find(".plan").each(function(i,item) {
                    if($(item).hasClass("ghost"))
                        return;
                    var otop=$(item).offset().top;
                    var otopmax=otop+55;
                    //test offset
                    console.log(i,otop,tOffset,otopmax, otop<=tOffset && tOffset<=otopmax,self.dragElement[0]===item);

                    if(otop<=tOffset && tOffset<=otopmax) {
                        //placed in here
                      //  console.log("RIGHT");
                        if(self.dragElement===item) {
                            //console.log("sameplace");
                        }else{
                            //console.log("not")
                            self.dragElement.swap(item);
                        }
                    }
                });

            }else{
                this.drag=true;
            }
        }
    }
});

$(function(){
    $(".floor-plan-field").each(function(i,item){
        if(item.floorplan)
            return;
        item.floorplan=new FloorPlanField(item);
    });
});